export default {
  // 头部
  publish: "发布",
  housingInfo: "房源信息",
  travelRoutes: "旅游路线",
  postHousing: "发布房源信息",
  postTravel: "发布旅游路线",
  headerSearchPlaceholder: "请输入内容",
  logoutSuccess: "已退出登录",
  pleaseEnterContent: "请输入搜索内容",
  aboutMe: "个人中心",
  merchantCert: "商户认证",
  logout: "退出登录",
  // 底部
  aboutUs: "关于我们",
  contactUs: "联系我们",
  followUs: "关注我们",
  phoneFooter: "电话",
  email: "邮箱",
  address: "地址",
  copyright: "© 2026 Move2china.com 版权所有",
  recordNo: "沪ICP备17051552号-1",
  // 悬浮工具栏
  wechatQRCode: "微信二维码",
  scanWechatContactService: "微信扫码<br />联系客服",
  customerService: "客服",
  servicePhone: "客服电话：",
  collect: "收藏",
  collected: "已收藏",
  backToTop: "返回顶部",
  expand: "展开",
  collapse: "收起",
  phoneCopied: "电话已复制",
  copyFailedPleaseRecord: "复制失败，请手动记录",
  // TravelSchedule 行程安排
  theDay: "第",
  deleteDay: "删除天数",
  selectTime: "选择时间",
  spot: "景点",
  detail: "详情",
  addSpot: "添加景点",
  addDay: "添加天数",
  spotDetailPlaceholder: "景点 {num} 详情",
  editorPlaceholder: "请输入景点详情（可添加图片和样式）",
  keepAtLeastOneDay: "至少保留一天行程安排",
  editorNotReady: "编辑器未就绪",
  insertImageFailed: "插入图片失败，请重试",
  // 导航栏
  allInfo: "所有信息",
  underReview: "审核中",
  approved: "审核通过",
  rejected: "审核驳回",
  // 搜索栏
  station: "站",
  departureLocation: "（出发地）",
  searchPlaceholder: "请输入目的地/景点/主题",
  search: "搜索",
  loadingCityData: "加载城市数据中...",
  loadCityFailed: "加载城市数据失败，请稍后重试",
  retry: "重试",
  recentCities: "最近切换城市",
  clear: "清空",
  searchCityPlaceholder: "支持汉字、首字母查询",
  searchCity: "搜索城市",
  // 首页
  hotServiceCategory: "热门服务分类",
  swipeToSeeMore: "滑动查看更多",
  recommendedServices: "推荐服务",
  bookNow: "立即预订",
  recommendedHouses: "推荐房源",
  viewMore: "查看更多",
  trustedPlatform: "值得信赖的服务平台",
  trustedPlatformDesc: "超过 10 万用户的选择，专业服务团队为您保驾护航",
  houseType: "户型",
  area: "区域",
  evaluation: "评价",
  // 登录注册
  login: "登录",
  register: "注册",
  forgetPassword: "忘记密码？",
  backToLogin: "去登录",
  findPassword: "找回密码",
  resetPassword: "重置密码",
  phone: "手机号",
  password: "密码",
  confirmPassword: "确认密码",
  newPassword: "新密码",
  username: "用户名",
  captcha: "验证码",
  smscode: "短信验证码",
  getCaptcha: "获取验证码",
  resendAfter: "s后重新获取",
  pleaseEnterPhone: "请输入手机号",
  pleaseEnterValidPhone: "请输入正确的手机号",
  pleaseEnterPassword: "请输入密码",
  passwordLength: "密码长度在6-20个字符",
  pleaseEnterCaptcha: "请输入验证码",
  pleaseEnterUsername: "请输入用户名",
  usernameLength: "用户名长度在2-10个字符",
  captchaLength: "验证码为4位数字",
  pleaseEnterRegisterPhone: "请输入注册手机号",
  pleaseRepeatPassword: "请再次输入新密码",
  formValidateFailed: "表单验证失败",
  loginSuccess: "登录成功！",
  registerSuccess: "注册成功",
  goToLogin: "前往登录？",
  passwordResetSuccess: "密码重置成功",
  // 个人中心侧边栏
  myListings: "我的清单",
  routeTemplate: "路线模板",
  favoriteList: "收藏列表",
  // 个人中心基本信息
  basicInfo: "基本信息",
  changeAvatar: "更换头像",
  avatarTip: "支持 JPG、PNG 格式，建议尺寸 100x100",
  account: "登录账号",
  wechat: "微信号",
  registerTime: "注册时间",
  edit: "修改",
  cancel: "取消",
  save: "保存",
  pleaseInputUsername: "请输入用户名",
  pleaseInputEmail: "请输入邮箱",
  pleaseInputWechat: "请输入微信号",
  avatarUploadSuccess: "头像上传成功",
  avatarFormatError: "头像只能是 JPG/PNG 格式!",
  avatarSizeError: "头像大小不能超过 5MB!",
  saveSuccess: "保存成功",
  saveFailed: "保存失败，请重试",
  // 个人中心实名认证
  realNameAuth: "实名认证",
  authTip: "实名认证将直接影响账号信息发布。",
  authDoc: "实名认证文档",
  enterpriseAuth: "企业认证",
  changeEnterpriseAuth: "变更企业认证",
  changeRecord: "变更记录",
  noAuthTip: "您还未进行商户认证，认证后可正常使用相关功能～",
  goToAuth: "去认证",
  enterpriseName: "企业名称",
  companyType: "公司类型",
  creditCode: "社会统一信用代码",
  handlerName: "签约人姓名",
  handlerIdCard: "签约人身份证号",
  applyTime: "申请时间",
  authMethod: "认证方式",
  // 个人中心商户认证变更
  merchantAuth: "商户认证",
  changeAuthTip: "变更企业认证将更新您的企业信息，审核期间不影响现有信息使用。",
  basicInfo1: "基础信息",
  merchantName: "商户名称",
  registerAddress: "注册地址",
  businessAddress: "实际经营地址",
  licenseStartDate: "营业执照开始日期",
  licenseEndDate: "营业执照结束日期",
  selectDate: "选择日期",
  selectType: "选择类型",
  selectCompanyType: "请选择公司类型",
  selectLastLevel: "请选择最末端的公司类型",
  businessLicense: "营业执照",
  uploadBusinessLicense: "上传营业执照",
  businessPermit: "经营许可(若所属行业需要)",
  uploadBusinessPermit: "上传经营许可",
  signerInfo: "签约人信息",
  signerName: "签约人姓名",
  idCardNumber: "身份证号码",
  position: "职务",
  selectPosition: "请选择职务",
  idCardPhoto: "身份证照片",
  idCardFront: "身份证正面",
  idCardBack: "身份证反面",
  uploadClickOrDrag: "请点击或拖拽上传原件照片或扫描件",
  uploadFormatTip: "支持 JPG、JPEG、PNG 格式，文件大小不超过 5MB",
  uploadPdfTip: "支持 PDF、JPG、JPEG、PNG 格式，文件大小不超过 5MB",
  delete: "删除",
  submitCheck: "提交审核",
  submitChange: "提交变更",
  uploading: "正在上传，请稍后...",
  fillRequiredInfo: "请完善所有必填信息",
  uploadRequiredFiles: "请上传所有必填的证件照片",
  submitSuccess: "提交成功，等待审核",
  changeSubmitSuccess: "变更申请提交成功",
  operationFailed: "操作失败",
  onlyAllowJpgPngPdf: "上传文件只能是 JPG、PNG 或 PDF 格式!",
  fileSizeLimit: "上传文件大小不能超过 5MB!",
  pleaseInputMerchantName: "请输入营业执照上的公司名称",
  pleaseInputCreditCode: "请输入统一社会信用代码",
  pleaseInputValidCreditCode: "请输入18位统一社会信用代码",
  pleaseInputRegisterAddress: "请输入营业执照上的注册地址",
  pleaseInputBusinessAddress: "请输入实际经营地址",
  pleaseSelectLicenseStartDate: "请选择营业执照开始日期",
  pleaseSelectLicenseEndDate: "请选择营业执照结束日期",
  pleaseInputSignerName: "请输入签约人姓名",
  pleaseInputIdCard: "请输入18位身份证号码",
  pleaseInputValidIdCard: "请输入正确的身份证号码",
  pleaseUploadBusinessLicense: "请上传营业执照",
  pleaseUploadIdCardFront: "请上传身份证正面照片",
  pleaseUploadIdCardBack: "请上传身份证反面照片",
  uploadError: "上传过程中发生错误，请重试",
  uploadFailed: "上传失败",
  getAuthInfoFailed: "获取认证信息失败",
  getAuthInfoFailedRetry: "获取认证信息失败，请重试",
  fileUploadFailed: "文件上传失败",
  draftSaved: "草稿已保存",
  draftRestored: "已恢复上次保存的草稿",
  draftRestoreFailed: "恢复草稿失败",
  file: "文件",
  deleted: "已删除",
  // 个人中心更改手机号
  changePhone: "修改手机号",
  back: "返回",
  currentPhone: "当前手机号",
  newPhone: "新手机号",
  verifyCode: "验证码",
  pleaseInputCurrentPhone: "请输入当前手机号",
  pleaseInputNewPhone: "请输入新手机号",
  pleaseInputValidPhone: "请输入正确的手机号",
  pleaseInputVerifyCode: "请输入验证码",
  getVerifyCode: "获取验证码",
  pleaseInputNewPhoneFirst: "请先输入新手机号",
  phoneNoNeedChange: "新旧手机号一致无需修改！",
  codeSent: "验证码已发送",
  getCodeFailedRetry: "获取验证码失败，请重试",
  phoneChangeSuccess: "手机号修改成功",
  changeFailedRetry: "修改失败，请重试",
  // 个人中心收藏列表
  collectionList: "收藏列表",
  routeName: "路线名称",
  searchRoutePlaceholder: "输入路线名称/出发地/目的地",
  filter: "筛选",
  reset: "重置",
  coverImage: "封面图",
  routeCover: "路线封面图",
  tripDays: "行程天数",
  departure: "出发地",
  destination: "目的地",
  price: "价格",
  collectTime: "收藏时间",
  operation: "操作",
  cancelCollection: "取消收藏",
  loadListFailed: "订单列表加载失败",
  // 个人中心订单列表
  orderList: "订单列表",
  searchOrder: "搜索订单",
  searchOrderPlaceholder: "搜索订单编号或名称",
  orderNo: "订单编号",
  productName: "产品名称",
  travelDate: "出行日期",
  status: "状态",
  createTime: "创建时间",
  goToPay: "去支付",
  cancelOrder: "取消订单",
  shareReview: "分享心得",
  reviewed: "已评价",
  allOrders: "所有订单",
  pendingPayment: "待支付",
  pendingTravel: "待出行",
  completed: "已完成",
  canceled: "已取消",
  loadOrderListFailed: "订单列表加载失败",
  viewOrderDetail: "查看订单 ",
  confirmCancelOrder: "确定要取消订单吗？",
  tip: "提示",
  confirm: "确定",
  orderCancelSuccess: "订单取消成功！",
  orderCancelFailed: "订单取消失败！",
  cancelOrderClosed: "已关闭取消订单",
  travelDateFormatError: "出行日期格式错误，无法继续支付",
  orderExpiredCannotPay: "已过出行日期，订单已失效，不可继续支付",
  // 个人中心旅游路线列表
  touristRoutes: "旅游路线",
  day: "天",
  enable: "启用",
  disable: "禁用",
  addTravelPlan: "添加出游行程",
  getRouteListFailed: "获取路线列表失败",
  networkErrorGetRouteFailed: "网络错误，无法获取路线列表",
  thisRoute: "这条路线",
  success: "成功",
  failed: "失败",
  networkErrorOperateFailed: "网络错误，操作失败",
  // 行程发布
  clickSelectRoute: "点击选择路线",
  noTemplateTip: "您暂未创建路线行程模版，请先创建新路线",
  trip: "行程",
  createNewRoute: "创建新路线",
  noTemplateAvailable: "暂无可选路线模版，请先添加出行路线",
  selectTravelDate: "选择出游日期",
  pleaseSelectRouteTemplate: "请选择路线模版",
  pleaseSelectTravelDate: "请选择出游日期",
  pleaseDoMerchantAuthFirst: "请先进行商户认证",
  getTemplateFailed: "获取模板失败",
  networkErrorGetTemplateFailed: "网络错误，获取模板失败",
  tripPublishSuccessWaitReview: "行程发布成功，等待审核",
  publishFailedRetry: "发布失败，请重试",
  networkErrorPublishFailed: "网络错误，发布失败",
  // 路线发布
  routeImageGallery: "路线图片锦集",
  cover: "封面",
  setAsCover: "设为封面",
  dragOrClickUpload: "将文件拖拽到此处，或点击上传",
  pleaseEnterRouteName: "请输入路线名称",
  pleaseEnterTripDays: "请输入行程天数",
  pleaseSelectOrSearchDeparture: "请选择或搜索出发地",
  pleaseSelectOrSearchDestination: "请选择或搜索目的地",
  minGroupSize: "最少成团人数",
  maxGroupSize: "最多成团人数",
  pleaseEnterMinGroupSize: "请输入最少成团人数",
  pleaseEnterMaxGroupSize: "请输入最多成团人数",
  mustBeGreaterThanZero: "必须大于0",
  productFeatures: "产品特点",
  enterTagPressEnter: "输入标签，按回车添加",
  pleaseAddAtLeastOneFeature: "请至少添加1个产品特点",
  pleaseEnterPrice: "请输入价格",
  priceMustBeGreaterThanZero: "价格必须大于0",
  tripMode: "行程方式",
  pleaseSelectTripMode: "请选择行程方式",
  playTheme: "游玩主题",
  pleaseSelectAtLeastOneTheme: "请选择至少一个游玩主题",
  introduction: "简介",
  pleaseEnterRouteIntro: "请输入路线简介",
  pleaseEnterIntroduction: "请输入简介",
  routeDetail: "路线详情",
  pleaseEnterRouteDetail: "请输入路线详情",
  tripSchedule: "行程安排",
  pleaseAddAtLeastOneDayTrip: "请添加至少1天行程",
  eachDayMustHaveAtLeastOneSpot: "每天行程至少包含1个景点",
  costDescription: "费用说明",
  pleaseEnterCostDescription: "请输入费用说明",
  servicePromise: "服务承诺",
  pleaseSelectAtLeastOneServicePromise: "请选择至少一个服务承诺",
  bookingNotice: "预订须知",
  pleaseEnterBookingNotice: "请输入预订须知",
  publishRoute: "发布路线",
  formReset: "表单已重置",
  onlyImagesCanBeUploaded: "只能上传图片文件！",
  uploadingPleaseWait: "正在上传，请稍后...",
  uploadingFile: "正在上传文件...",
  uploadErrorPleaseRetry: "上传过程中发生错误，请重试",
  imageUploadFailed: "图片上传失败",
  imageUploadFailedPleaseRetry: "图片上传失败，请重试",
  insertImageFailedPleaseRetry: "插入图片失败，请重试",
  daysMustBeGreaterThanZero: "天数必须大于0",
  pleaseEnterDeparture: "请输入出发地",
  pleaseEnterDestination: "请输入目的地",
  loadEditDataFailed: "加载编辑数据失败",
  getCityListFailed: "获取城市列表失败：",
  getCityListErrorPleaseRetry: "获取城市列表异常，请稍后重试",
  pleaseUploadAtLeastOneImage: "请至少上传1张图片",
  publishSuccess: "发布成功",
  publishFailedPleaseRetry: "发布失败，请重试",
  editSuccess: "编辑成功",
  editFailedPleaseRetry: "编辑失败，请重试",
  networkErrorOperationFailed: "网络错误，操作失败",
  pleaseInputChineseOnly: "{field} 仅允许填写中文",
  pleaseInputEnglishOnly: "{field} Only English is allowed",
  langRuleTip: "当前为中文模式，仅允许填写中文内容",
  langRuleTipEn: "当前为英文模式，仅允许填写英文内容",
  // 订单评价
  orderEvaluation: "订单评价",
  traveler: "出行人",
  orderAmount: "订单金额",
  shareYourExperience: "请分享您的体验",
  overallRating: "总体评分",
  reviewContent: "评价内容",
  pleaseShareTravelExperience: "请分享您的旅行体验和感受...",
  uploadImages: "上传图片",
  uploadImageTip: "最多上传5张图片，支持JPG、PNG格式",
  submitReview: "提交评价",
  reviewSubmittedSuccessfully: "评价提交成功，感谢您的反馈！",
  veryPoor: "很差",
  average: "一般",
  good: "良好",
  veryGood: "很好",
  excellent: "非常好",
  pleaseGiveRating: "请给出您的评分",
  pleaseEnterReviewContent: "请输入评价内容",
  reviewContentMaxLength: "评价内容不能超过500个字",
  maxUpload5Images: "最多只能上传5张图片",
  canStillUpload: "您还可以上传",
  images: "张",
  ratingLowContactService: "若您对行程有不满，可联系客服协助处理",
  reviewSubmitFailed: "评价提交失败",
  networkErrorOrderInfoFailed: "网络异常，订单信息加载失败，请稍后重试",
  networkErrorReviewSubmitFailed: "网络异常，评价提交失败，请稍后重试",
  // 路线列表
  travelMode: "出行方式",
  groupSize: "成团人数",
  priceRange: "价格范围",
  all: "不限",
  minPrice: "最低",
  maxPrice: "最高",
  yuan: "元",
  currencySymbol: "",
  yuanAbove: "元以上",
  clearFilters: "清空筛选",
  selected: "已选",
  itemsFound: "个产品满足条件",
  sortBy: "请选择排序",
  publishDate: "发布时间",
  sales: "销量",
  perPerson: "起/人",
  score: "分",
  sold: "已售",
  noResult: "没有符合检索要求的产品",
  travelGuide: "旅游指南",
  hotTop5: "热卖 TOP5",
  loadFailedRetry: "加载数据失败，请重试",
  minNotGreaterThanMax: "最低价格不能大于最高价格",
  // 行程详情
  share: "分享",
  routeImage: "路线图片",
  thumbnail: "缩略图",
  productInfo: "产品信息",
  productNo: "产品编号",
  departDest: "出发地/目的地",
  recentTrip: "近期行程",
  undetermined: "待定",
  historySales: "历史成交",
  order: "单",
  satisfaction: "满意度",
  commentCount: "评论数量",
  piece: "条",
  serviceProviderTip1: "本次行程将由",
  serviceProviderTip2: "为您提供服务",
  routeIntro: "路线简介",
  costInfo: "费用说明",
  basedOn: "基于",
  reviews: "条评价",
  adult: "成人",
  room: "房间",
  themeRec: "主题推荐",
  recentDate: "近期行程日期",
  to: "至",
  serviceProvider: "服务商",
  unknownProvider: "未知服务商",
  totalPrice: "总价",
  userReviews: "游客评价",
  avatar: "用户头像",
  reviewImg: "评价图片",
  viewAll: "查看全部",
  total: "总价",
  loading: "加载中",
  noMore: "没有更多评价了",
  getDateFailed: "获取可用日期失败",
  pleaseSelectDate: "请选择出游日期",
  pleaseFillBookingInfo: "请填写完整的预订信息",
  linkCopied: "分享链接已复制",
  copyFailed: "复制失败，请手动复制",
  getReviewFailed: "获取评价失败",
  networkErrorGetReviewFailed: "网络错误，获取评价失败",
  roomCannotExceedAdult: "房间数不能超过成人数",
  autoAdjustTo: "已自动调整为",
  current: "当前",
  person: "人",
  // 支付页面
  confirmPayment: "确认支付",
  orderInfo: "订单信息",
  bookCount: "预订人数",
  roomCount: "房间数量",
  roomUnit: "间",
  payAmount: "支付金额",
  totalPay: "应付金额",
  feeIncludeTip: "费用包含行程内交通、服务等，具体以订单详情为准",
  selectPayMethod: "选择支付方式",
  alipay: "支付宝支付",
  wechatPay: "微信支付",
  preparingPay: "正在准备",
  payQrcode: "支付二维码",
  qrcodeExpire: "二维码有效期",
  timeoutRefresh: "超时后需重新获取",
  scannedPleasePay: "已扫码，请在新页面完成支付",
  openPayTool: "打开{method}",
  scanQrcodePay: "扫描上方二维码完成支付",
  refreshQrcode: "刷新二维码",
  paidAlready: "已完成支付？",
  qrcodeExpiredRefresh: "支付二维码已过期，请重新生成",
  refreshNow: "立即重新生成",
  generatingQrcode: "正在生成{method}支付二维码",
  payResult: "支付结果",
  paySuccess: "支付成功",
  payUnfinished: "支付未完成",
  checkingPayStatus: "查询支付状态中",
  paySuccessTip: "您已成功完成支付，订单将在1-5分钟内确认",
  payUnfinishedTip: "未检测到支付记录，请完成支付或重新生成二维码",
  checkingStatusTip: "正在查询您的支付状态，请稍候...",
  viewOrder: "查看订单信息",
  backToDetail: "返回详情页",
  orderInfoFail: "订单信息获取失败",
  defaultRoute: "默认旅行路线",
  createPayOrderFail: "创建支付单失败，请重试",
  networkError: "网络异常，请检查网络",
  generatedQrcode: "已生成",
  qrcodeGenerateFail: "二维码生成失败，请重试",
  requestError: "请求异常，请检查网络或联系客服",
  qrcodeExpiredTip: "二维码已过期，请重新选择支付方式获取",
};
